import { Component, OnInit, Output, EventEmitter, TemplateRef } from '@angular/core';
import { IInstallationMeter } from 'projects/pplus/src/lib/interfaces/interfaces';
import { FormGroup, FormControl } from '@angular/forms';
import { DynamicForm } from 'projects/pplus/src/lib/models/components/dynamic-form.model';
import { InstallationMetersService } from '../installation-meters.service';
import { InstallationMetersDetailsService } from './installation-meters-details.service';
import { RowDataService } from 'projects/pplus/src/lib/components/split-form/services/row-data.service';
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { AdminService } from '../../admin.service';
import * as moment from 'moment';
import { NbDialogService } from '@nebular/theme';
import { InstallationService } from '../../installations/installations.service';
import { PlantService } from '../../plant/plant.service';
import { DATE_FORMAT } from '../../admin.model';

@Component({
  selector: 'pplus-installation-meters-details',
  templateUrl: './installation-meters-details.component.html',
  styleUrls: ['./installation-meters-details.component.scss']
})
export class InstallationMetersDetailsComponent implements OnInit {
  @Output() splitOptions = new EventEmitter();
  @Output() updateDelete = new EventEmitter();

  data: IInstallationMeter;

  formGroup: FormGroup;
  formData: DynamicForm[];

  constructor(
    private installationMetersService: InstallationMetersService,
    private installationMetersDetailsService: InstallationMetersDetailsService,
    private rowDataService: RowDataService,
    private adminService: AdminService,
    private nbDialogService: NbDialogService,
    private installationService: InstallationService,
    private plantService: PlantService,
  ) {
    this.formData = this.installationMetersDetailsService.getDynamicForm();
  }

  ngOnInit() {
    forkJoin([
      this.installationMetersService.getTypes(),
      this.installationService.getList(),
      this.plantService.getPlantList(),
    ]).subscribe(([meterTypes, installations, plants]) => {
      this.formData.map(o => {
        o.fields.forEach(f => {
          if (f.name === 'meterTypeId') {
            const opts = [];
            meterTypes.map(mt => opts.push({
              value: mt.meterTypeId,
              label: mt.name,
            }));
            f.options = opts;
          } else
          if (f.name === 'installationId') {
            const opts = [];
            installations.map(i => opts.push({
              value: i.installationId,
              label: i.name,
            }));
            f.options = opts;
          } else
          if (f.name === 'plantId') {
            const opts = [];
            plants.map(p => opts.push({
              value: p.plantId,
              label: p.name,
            }));
            f.options = opts;
          }
        });
      });
      this.generateForm(this.formData);
    });

    this.rowDataService.currentRowData.pipe(map(o => {
      this.formData.forEach(data => {
        const fields = data.fields;
        fields.map(field => {
          if (o[field.name] != null && o[field.name] !== '') {
            field.value = o[field.name];
          }
        });
      });
      return o;
    })).subscribe(data => {
      this.data = <IInstallationMeter>data;
      this.generateForm(this.formData);
    });
  }

  private generateForm(data: DynamicForm[]) {
    const fieldsCtrls = {};
    data.forEach(el => {
      const fields = el.fields;
      fields.forEach(f => {
        fieldsCtrls[f.name] = new FormControl(f.value, f.validators);
      });
    });
    this.formGroup = new FormGroup(fieldsCtrls);
  }

  onSubmit() {
    if (this.formGroup.invalid) {
      this.adminService.showFormValidationErrors(this.formGroup, this.formData);
    } else {
      const data = <IInstallationMeter>this.formGroup.value;
      data.activated = Boolean(data.activated);
      this.installationMetersService.create(data).subscribe(newInstallationMeter => {
        if (newInstallationMeter != null) {
          newInstallationMeter.creationDate = moment(newInstallationMeter.creationDate).format(DATE_FORMAT);
          newInstallationMeter.deletionDate = moment(newInstallationMeter.deletionDate).format(DATE_FORMAT);
          newInstallationMeter.readingStartDate = moment(newInstallationMeter.readingStartDate).format(DATE_FORMAT);
          newInstallationMeter.lastReadDate = moment(newInstallationMeter.lastReadDate).format(DATE_FORMAT);
          newInstallationMeter.lastEventDate = moment(newInstallationMeter.lastEventDate).format(DATE_FORMAT);
          this.formGroup.patchValue(Object.assign(this.data, newInstallationMeter));
          this.updateDelete.emit(true);
          this.adminService.showToast('success',
              'Se ha creado el nuevo contador de instalación: ' + data.name,
              'Elemento creado');
        } else {
          this.adminService.showToast('danger',
              'Se ha producido un error al crear el contador de instalación: ' + data.name,
              'Error');
        }
      });
    }
  }

  update() {
    const installationMeterId = this.data.installationMeterId;
    if (installationMeterId == null) {
      this.onSubmit();
    } else if (this.formGroup.invalid) {
      this.adminService.showFormValidationErrors(this.formGroup, this.formData);
    } else {
      const data = <IInstallationMeter>this.formGroup.value;
      data.activated = Boolean(data.activated);
      this.installationMetersService.update(installationMeterId, data).subscribe(success => {
        if (success) {
          this.updateDelete.emit();
          this.adminService.showToast('success',
              'Se ha actualizado el contador de instalación: ' + data.name,
              'Elemento actualizado');
        } else {
          this.adminService.showToast('danger',
              'Se ha producido un error al actualizar el contador de instalación: ' + data.name,
              'Error');
        }
      });
    }
  }

  delete() {
    if (this.data.installationMeterId == null) {
      this.adminService.showToast('info', 'Seleccione un contador de instalación', 'Info');
    } else {
      this.installationMetersService.delete(this.data.installationMeterId).subscribe(success => {
        if (success) {
          this.updateDelete.emit();
          this.adminService.showToast('success',
              'Se ha borrado el contador de instalación: ' + this.data.name,
              'Elemento eliminado');
          this.clearData();
        } else {
          this.adminService.showToast('danger',
              'Se ha producido un error al borrar el contador de instalación: ' + this.data.name,
              'Error');
        }
      });
    }
  }

  close() {
    const opt = {
      open: false,
      direction: 'horizontal',
      contentSize: 100,
      formSize: 0,
    };
    this.splitOptions.emit({ opt, mode: 'default' });
    this.clearData();
  }

  copy() {
    if (this.data.installationMeterId == null) {
      this.adminService.showToast('info', 'Seleccione un contador de instalación para copiar la información', 'Info');
    } else {
      this.formGroup.patchValue(Object.assign(this.data, <IInstallationMeter>{
        installationMeterId: null,
        serialNumber: '',
        name: '',
        code: '',
        installationId: null,
        plantId: null,
        creationDate: '',
        deletionDate: '',
        lastReadDate: '',
        lastEventDate: '',
        addressLink: '',
        numberPhone: '',
        ip: '',
        portTcp: '',
        addressClient: '',
      }));
    }
  }

  clearData() {
    this.data = <IInstallationMeter>{};
    this.formGroup.reset();
  }

  openDialog(dialog: TemplateRef<any>) {
    if (this.data.installationMeterId == null) {
      this.adminService.showToast('info', 'No hay ningún contador de instalación seleccionado', 'Info');
    } else {
      this.nbDialogService.open(dialog, { context: '¿Desea eliminar el contador de instalación?', hasScroll: false });
    }
  }

}
